import { message } from 'antd';
import { toggleAlert } from '@src/api/manualAlerts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trackQueryError } from '@src/utils/sensor/apptracker';

const useToggle = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ alertId, state }: any) => {
      return toggleAlert(alertId, { state });
    },
    {
      onSuccess: (response) => {
        const { state, name } = response.data;
        queryClient.invalidateQueries(['manual-alert', 'list']);
        message.success(`Alert ${name} ${state ? 'enabled' : 'disabled'}!`);
      },
      onError: (err) => {
        trackQueryError({ type: 'manual-alert-toggle', err });
      },
    },
  );

  return mutation;
};

export default useToggle;
